<template>
  <div class="main-class">
    <v-card class="card-class ma-auto py-3" max-width="750">

      <v-card-text>

        <div class="d-block my-3" @click="cityDialog = true">
          <div class="my-3 input-class">
            <v-icon>
              apartment
            </v-icon>
            <div class="mx-2 text-button">
              {{ cityValue ? cityValue.name : '请选择...' }}
            </div>
          </div>
          <v-divider></v-divider>
        </div>

        <div class="d-block my-3" @click="positionDialog = true">

          <div class="my-3 input-class">
            <v-icon>
              work
            </v-icon>
            <div class="mx-2 text-button">
              {{ positionValue ? positionValue.name : '请选择...' }}
            </div>
          </div>
          <v-divider></v-divider>
        </div>

      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn block color="primary" @click="submit">
          提交
        </v-btn>
      </v-card-actions>
    </v-card>

    <div>
      <v-dialog
          v-model="cityDialog"
          width="600px"
          scrollable
      >
        <v-card>
          <v-card-title>
            选择地区
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-city :data="cityList" @change="cityChange"></v-city>
          </v-card-text>
        </v-card>

      </v-dialog>

    </div>

    <div>
      <v-dialog
          v-model="positionDialog"
          width="600px"
          scrollable
      >
        <v-card>
          <v-card-title>
            选择职业
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-position :data="positionConfigList" @change="positionChange"></v-position>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-message :content="msg"></v-message>


  </div>
</template>

<script>
import {newCity, positionConfigList} from '@/api/resources/salary'

import city from '@/components/salary/city'
import position from '@/components/salary/position'
import message from "@/components/Message";
import {mapMutations} from "vuex";

export default {
  name: "new",
  data: () => ({
    cityValue: undefined,
    positionValue: undefined,
    cityDialog: false,
    positionDialog: false,
    // infoDialog: false,
    positionConfigList: [],
    cityList: [],
    msg: {
      snackbar: false,
      text: '',
    }
  }),
  components: {
    'v-city': city,
    'v-position': position,
    'v-message': message
  },
  created() {
    this.init()
    // this.format(this.positionConfigList)
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    cityChange(code, name) {
      this.cityValue = {
        code, name
      }
      this.cityDialog = false
    },
    positionChange(code, name) {
      this.positionValue = {
        code, name
      }
      this.positionDialog = false
    },
    submit() {

      if (!this.cityValue || this.cityValue.code === undefined) {
        this.msg = {
          snackbar: true,
          text: '请选择城市!',
        }
        return;
      }

      if (!this.positionValue || !this.positionValue.code) {
        this.msg = {
          snackbar: true,
          text: '请选择行业!',
        }
        return;
      }

      this.$router.push({
        path: '/salary/info',
        query: {
          positionId: this.positionValue.code,
          positionName: this.positionValue.name,
          cityValue: this.cityValue.code,
          cityName: this.cityValue.name
        }
      })

    },
    init() {
      this.setLoading();
      Promise.all([this._newCity(), this._positionConfigList()])
          .then(([newCity, positionConfigList]) => {

            this.cityList = newCity.data

            this.positionConfigList = positionConfigList.data

            this.clearLoading();
            // this.hotPosition = hotPosition.zpData
          })
    },
    _newCity() {
      return new Promise((resolve, reject) => {
        newCity().then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e);
        })
      })
    },
    _positionConfigList() {
      return new Promise((resolve, reject) => {
        positionConfigList().then(res => {
          resolve(res.data)
        }).catch(e => {
          reject(e);
        })
      })
    },
    // _hotPosition() {
    //   return new Promise((resolve, reject) => {
    //     hotPosition().then(res => {
    //       resolve(res.data)
    //     }).catch(e => {
    //       reject(e);
    //     })
    //   })
    // },
    // format(list) {
    //   list.forEach(item => {
    //     if (!item.subLevelModelList) {
    //       item.subLevelModelList = []
    //     } else {
    //       this.format(item.subLevelModelList)
    //     }
    //   })
    //   return list
    // }

  }
}
</script>

<style scoped>

.main-class {
  width: 100%;
  height: 100%;
}

.input-class {
  display: flex;
  align-content: center;
  flex-flow: row wrap;
  height: 100%;
}

</style>
